import FormControl from "../../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik } from "formik";
import React,{useRef} from "react";
import reportsService from "../../../../Service/Reports/reports.service";
import ReactToPrint from "react-to-print";
import { pageStyle } from "../../../Print/printPagesStyles";
import BasicTable from "../../../MUI_components/Table/basicTable";
import ReportPrintTable from "../../reportPrintTable";
import { Button, Paper, Table, TableHead, TableRow } from "@mui/material";
import { useDispatch } from "react-redux";
import { openSnackbar } from "../../../../Redux/Actions/snackbarActions";
import Reports from "../../../../Components/Reports/reports";
import supplierService from "Service/Suppliers/supplier.service";

import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Title from "Components/Card/title";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";

export default function DebitStatement() {
  const dispatch = useDispatch();
  const [results, setResults] = React.useState({
    rows: [],
    supplier: null,
    loading: false,
  });
  const tableRef = useRef(null);

  const HeadCells = [
    {
      key: (val) => {
        return val["code"];
      },
      align: "left",
      label: COLUMNS_NAME.CODE,
    },
    {
      key: (val) => {
        return val["name"];
      },
      align: "left",
      label: COLUMNS_NAME.SUPPLIER,
    },
    {
      key: (val) => {
        return val["overPayment"] ? val["overPayment"] : 0;
      },
      align: "right",
      label: COLUMNS_NAME.OVERPAYMENT,
      currency: true,
    },
    {
      key: (val) => {
        return val["returnAmount"] ? val["returnAmount"] : 0;
      },
      align: "right",
      label: COLUMNS_NAME.RETURNAMOUNT,
      currency: true,
    },
    {
      key: (val) => {
        return val["debitAmount"] ? val["debitAmount"] : 0;
      },
      align: "right",
      currency: true,
      label: COLUMNS_NAME.DEBIT_BALANCE,
    },
    // {
    //   key: (val) => (val.map((props) => parseFloat(props["creditAmount"]))
    //     .reduce((sum, i) => sum + i, 0)),
    //   align: "right",
    //   currency: true,
    //   label: "Credit Amount",
    // }
  ];
  const componentRef = React.useRef();

  const handleSubmit = async (values) => {
    setResults({
      ...results,
      loading: true,
    });
    try {
      const res = await reportsService.DebitStatement(
        values.supplier ? values.supplier.code : ""
      );
      // console.log(res);
      const filteredRows = res.debitStatement.filter((row) => row.debitAmount !== "0.00");
      setResults({
        loading: false,
        rows: filteredRows,
        supplier: values.supplier,
      });
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };
  const billTotalOverPayment = results.rows
  .map((props) => parseFloat(props["overPayment"]))
  .reduce((sum, i) => sum + i, 0);

  const billTotalReturnAmount = results.rows
  .map((props) => parseFloat(props["returnAmount"]))
  .reduce((sum, i) => sum + i, 0);

  const billTotal = results.rows
  .map((props) => parseFloat(props["debitAmount"]))
  .reduce((sum, i) => sum + i, 0);

  return (
    <div style={{ display: 'flex', width: '100%' }}>
    <div >
      <Reports />
    </div>
    <div style={{width: '100%'}}>
      <Formik
        initialValues={{
          supplier: null,
        }}
        onSubmit={handleSubmit}
      >
        {() => {
          return (
            <Form>
              <Title>Debit Statement</Title>
              <div className="flex mt mb">
                <div className="col-4">
                  <FormControl
                    control="asynchronousAutoComplete"
                    name="supplier"
                    size="small"
                    Service={supplierService}
                    label="Supplier"
                    getOptionLabel={(option) =>
                      option.name +
                      " " +
                      option.code
                    }
                  />
                </div>
                <div className="col-6">
                  <Button variant="contained" type="submit" color="primary">
                    Find
                  </Button>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
      <Paper>
        <div className="flex-end">
          <ReactToPrint
            trigger={() => (
              <Button
                style={{ margin: 5 }}
                disabled={!results.rows.length}
                variant="contained"
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={pageStyle.a4}
          />

<DownloadTableExcel
            filename="ageingSummery"
            currentTableRef={tableRef.current}
          >
            <Button
              style={{ margin: 5 }}
              disabled={!results.rows.length}
              variant="contained"
            >
              Export to Excel </Button>
          </DownloadTableExcel>
        </div>
        <div style={{display: "none" }}>
         
            <Reports    >
            <div ref={componentRef}>
              <ReportPrintTable
              title={`Debit Statement  Location : ${JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).name}`}
                headCells={HeadCells}
                rows={results.rows}
                //billTotal={billTotal}
              >
                 <tr>
                  <th colSpan={2}></th>
                  <th align="center">
                    {COLUMNS_NAME.LAST_TOTAL}
                  </th>
                 
                  <th align="right" >{currency(billTotalOverPayment)}</th>
                  <th>{currency(billTotalReturnAmount)}</th>
                  <th >
                    {currency(billTotal)}
                  </th>
                </tr>
              </ReportPrintTable>
              </div>
            </Reports>
          
        </div>

        <BasicTable
          headCells={HeadCells}
          rows={results.rows}
          isLoaded={results.loading}
          tableRef={tableRef}
        />
      </Paper>
    </div>
    </div>
  );
}
